import classNames from "classnames";
import React from "react";
import { SupportSidePanel } from "../components/SidePanel/Support/SupportSidePanel";
import SupportArticleLink from "./SupportArticleLink";

const classes = (white?: boolean, small?: boolean) => classNames({
  "icon-question": !small,
  "icon-question-o": small,
  s1_small: !small,
  s1_gray: !white
});

interface SupportQuestionMarkProps {
  articleId: number
  openInNewTab?: boolean
  white?: boolean
  small?: boolean
}

const SupportQuestionMark = (props: SupportQuestionMarkProps) => {
  const { articleId, openInNewTab, white, small } = props;

  // Rendering fallback for MainWebUI. This can be removed once we get rid of MainWebUI.
  if (!document.getElementById("app")) {
    return <a
      className={classes(white, small)}
      onClick={(e) => {
        e.stopPropagation();
        window.OpenSupportSidebar(articleId);
      }}
    />;
  }

  if (openInNewTab) {
    return <SupportArticleLink
      articleId={articleId}
      className={classes(white, small)}
    />
  }

  return <SupportSidePanel
    articleId={articleId}
    trigger={<a tabIndex={-1} onClick={() => { }} className={classes(white, small)} />}
  />
};

export default SupportQuestionMark;